// Structure figée partagée entre la tablette et l'admin
export const BAR_STRUCTURE = [
  { label: "À partager",   tiles: ["Planches & Assiettes"] },
  { label: "Boissons",     tiles: ["Cocktails", "Vins au Verre", "Apéritifs", "Bières", "Softs", "Boissons Chaudes"] },
  { label: "Gourmandises", tiles: ["Après-midi Gourmands", "Coupes de Glaces", "Gaufres"] },
  { label: "Spiritueux",   tiles: ["Whiskys & Bourbons", "Digestifs"] },
];

export const BISTRO_STRUCTURE = [
  { label: "À partager",   tiles: ["Assiettes Apéro"] },
  { label: "Restauration", tiles: ["Formules (du jour & de saison)", "Les fruits de mer", "Entrées", "Plats", "Suggestions", "Menu Enfant"] },
  { label: "Vins",         tiles: ["Vins rouges", "Vins blancs", "Rosés"] },
  { label: "Boissons",     tiles: ["Apéritifs & Cocktails", "Champagnes & Pétillants", "Bières", "Softs & Eaux", "Boissons Chaudes"] },
  { label: "Desserts",     tiles: ["Fromages", "Desserts", "Coupes de Glaces"] },
  { label: "Digestifs",    tiles: ["Les rhums", "Les liqueurs", "Les eaux de vie et marcs"] },
];

// Tuiles gérées ailleurs (admin dédié), pas de saisie libre d'items
export const BISTRO_LOCKED_TILES = ["Formules (du jour & de saison)", "Menu Enfant"];

export const BAR_TILES = BAR_STRUCTURE.flatMap((c) => c.tiles);
export const BISTRO_TILES = BISTRO_STRUCTURE.flatMap((c) => c.tiles);
